import {Component} from "../../../gvf/js/component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../../cp/js/utils-service";

export class BudgetSummary extends Component{

    addWorktopToCart(withContract=false){
        GvfService.endpoint(
            "/web/web/add-worktop-to-cart",
            {withContract}
        ).then(
            (resp) => {
                if(resp.popupHtml){
                    var $popupConfirm = $(resp.popupHtml);
                    $("body").append($popupConfirm);
                    $popupConfirm.fadeIn();
                    $popupConfirm.find(".js-popup-confirm__ok").click(
                        (ev) => {
                            ev.preventDefault();
                            $popupConfirm.fadeOut();
                            window.location = window.location.href.split("#")[0];
                        }
                    );
                    $popupConfirm.find(".js-popup-confirm__close").click(
                        (ev) => {
                            ev.preventDefault();
                            $popupConfirm.fadeOut();
                            window.location = window.location.href.split("#")[0];
                        }
                    );
                }
            }
        );
    }

    ready(){
        super.ready();

        this.findMember("block-title-a").click(
            (ev)=>{
                ev.preventDefault();
                var $block = $(ev.currentTarget).closest(this.scope+"__block");
                var $open = $(ev.currentTarget).find(this.scope+"__open");
                var $close = $(ev.currentTarget).find(this.scope+"__close");
                if(!$block.hasClass("is-open")){
                    this.$root.find(this.scope+"__open").hide();
                    this.$root.find(this.scope+"__close").show();
                    this.$root.find(this.scope+"__block").removeClass("is-open");
                    $block.addClass("is-open");
                    $close.hide();
                    $open.show();
                }else{
                    $block.removeClass("is-open");
                    $close.show();
                    $open.hide();
                }
            }
        );

        this.findMember("discard-budget").click(
            ()=>{
                GvfService.endpoint(
                    "/web/web/cancel-current-product",
                    {}
                ).then(
                    (resp)=>{
                        window.location.replace(resp.url);
                    }
                );
            }
        );

        this.findMember("addWorktopCard").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web/get-modal-to-confirm-worktop",
                    {}
                ).then(
                    (resp)=>{
                        if(resp.popupHtml){
                            var $popup = $(resp.popupHtml);
                            $("body").append($popup);
                            $popup.fadeIn();
                            $popup.find(".js-popup-measurement__add").click(
                                ()=>{
                                    ev.preventDefault();
                                    $popup.fadeOut();
                                    this.addWorktopToCart(true);
                                }
                            );
                            $popup.find(".js-popup-measurement__delete").click(
                                ()=>{
                                    ev.preventDefault();
                                    $popup.fadeOut();
                                    this.addWorktopToCart();
                                }
                            );
                            $popup.find(".js-popup-confirm__close").click(
                                (ev)=>{
                                    ev.preventDefault();
                                    $popup.fadeOut();
                                }
                            );
                        }
                        if(resp.ok){
                            this.addWorktopToCart(true);
                        }
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );

        this.findMember("saveBudget").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web/save-budget",
                    {}
                ).then(
                    (resp)=>{
                        if(resp.url){
                            window.location = resp.url;
                        }
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );
        this.findMember("returnBudget").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web/return-budget",
                    {}
                ).then(
                    (resp)=>{
                        if(resp.url){
                            window.location = resp.url;
                        }
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );

        this.findMember("download-budget").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web/download-worktop-pdf",
                    {budgetId: this.$root.data("budget-id"),docType: $(ev.currentTarget).data("value")}
                ).then(
                    (resp)=>{
                        if(resp.url){
                            window.location = resp.url;
                        }

                    }
                );
            }
        );

        this.findMember("create-new-budget").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint(
                    "/web/web/create-new-budget",
                    {}
                ).then(
                    (resp)=>{
                        window.location = resp.url;
                    }
                );
            }
        );

    }
}

